import { graphql } from 'graphql-schema';
import { SCHEDULE_GAME_FRAGMENT } from '../../../../apps/RFO/Manage/Schedule/graphql';

const LEAGUE_TOURNAMENT_QUERY = graphql(
  `
    query leagueTournamentData($program: uuid!) {
      league: leagues_by_pk(_id: $program) {
        _id
        timezone
        teams {
          _id
          color_hex
          name
        }
        tournaments {
          _id
          challonge_id
          name
          schedule
          start_at
          tournament_type
          url
          games {
            ...ScheduleGameFragment
          }
        }
      }
    }
  `,
  [SCHEDULE_GAME_FRAGMENT]
);

export default LEAGUE_TOURNAMENT_QUERY;

export const DELETE_TOURNAMENT = graphql(`
  mutation deleteTournament($subscheduleId: uuid!) {
    deleteTournament(subscheduleId: $subscheduleId) {
      subschedule
    }
  }
`);

export const UPDATE_TOURNAMENT_DATE = graphql(`
  mutation updateTournamentDate(
    $tournamentId: uuid!
    $date: timestamptz!
    $gameUpdates: [games_updates!]!
  ) {
    update_tournaments_by_pk(pk_columns: { _id: $tournamentId }, _set: { start_at: $date }) {
      _id
    }
    update_games_many(updates: $gameUpdates) {
      returning {
        _id
        date
        end_time
        end_time_str
        start_time
        start_time_str
      }
    }
  }
`);
